const initialState = {
    filterCriteria : {},
    deviceList : [],
    size : 0,
    start : 0,
    end : 10,
    pageNumber : 1,
    totalSize:0,
    sortOrder : null,
    sortColumn : null,
    deviceTypes : [],
    deciveGroups : [],
    nextToken : null,
    deviceCount : 0,
    deviceDetails:[],
    error:null,
    campaignDetails:[],
    reportHistoryFetching:false,
    reportHistoryFetched:false,
    reportHistoryDetails:{},
    reportHistoryError:null,
    reportUrlFetching:false,
    reportUrlFetched:false,
    reportUrlDetails:{},
    reportUrlError:null

}

export default function reducer(state = initialState, action) {
    switch(action.type) {
        case 'FETCH_REPORT_SUCCESS' : {
            const campaignDetailArray = action.payload.data.data.data;
            const total =action.payload.data.data;
            // const devices = state.deviceList.concat(deviceDetailArray.devices);
            // console.log(devices)
            return { 
                ...state,
                // deviceList : devices, 
                campaignDetails : campaignDetailArray, 
                start : action.payload.start,
                end : action.payload.end,
                pageNumber : action.payload.pageNumber,
                totalSize: total.total_size
            }
        }
        case "FETCH_REPORT_REJECTED": {
            return {...state, error: action.payload}
        }
        case 'CLEAR_REPORT_MANAGEMENT' : {
            return {
                ...state,
                filterCriteria : {},
                deviceList : [],
                size : 0,
                start : 0,
                end : 10,
                pageNumber : 1,
                sortOrder : null,
                sortColumn : null,
                deviceTypes : [],
                deciveGroups : [],
                nextToken : null,
                deviceCount : 0,
                deviceDetails:[]
            }
        }
        case 'LOAD_NEXT_PAGE' : {
            return {
                ...state,
                start : action.payload.start,
                end : action.payload.end,
                pageNumber : action.payload.pageNumber,
                message : null
            }
        }
        case 'FETCH_REPORT_HISTORY_REQUEST' : {
            return {...state, reportHistoryFetching:true}
        }

        case 'FETCH_REPORT_HISTORY_SUCCESS' : {
            return {...state,reportHistoryFetching:false,reportHistoryFetched:true,reportHistoryDetails:action.payload}
        }
        case 'FETCH_REPORT_HISTORY_FAILURE' : {
            return {...state,reportHistoryFetching:false,reportHistoryError:action.payload}
        }

        case 'FETCH_REPORT_URL_REQUEST':{
            return {...state, reportUrlFetching:true}
        }

        case 'FETCH_REPORT_URL_SUCCESS' : {
            return {...state,reportUrlFetching:false,reportUrlFetched:true,reportUrlDetails:action.payload}
        }

        case 'FETCH_REPORT_URL_FAILURE' : {
            return {...state,reportUrlFetching:false,reportUrlFetched:true,reportUrlDetails:action.payload}
        }

        
    }
    return state
}